import { BaseOption } from 'models';

export class Payment {
	token: string;

	constructor(props: { [key in keyof Payment]: Payment[key] }) {
		Object.assign(this, props);
	}
}

export class PaymentStatus extends BaseOption {}

export enum PaymentStatuses {
	Unpaid = 1,
	InProgress = 2,
	Paid = 3,
	Refunded = 4,
	Failed = 5,
	Cancelled = 6,
	RefundFailed = 7,
	FailedWithRetry = 8,
	PaidManually = 9,
}
